// src/firebase/config.js
// Version: 1.1.5 - Updated storageBucket based on user confirmation

import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
  apiKey: "AIzaSyCtAy2-KpytJOq6f2fTT5g-vXahqT3NNvk", 
  authDomain: "interactive-questionnaire.firebaseapp.com",
  projectId: "interactive-questionnaire",
  // Ensure this is the correct bucket name as confirmed from your Firebase Console
  storageBucket: "interactive-questionnaire.firebasestorage.app", // <-- VERIFY & UPDATE THIS LINE
  messagingSenderId: "204811331401",
  appId: "interactive-questionnaire-app", 
  measurementId: "G-LNDQ2T86L8" 
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Firebase: Error setting auth persistence", error);
  });

const db = getFirestore(app);
const storage = getStorage(app); 

// Determine APP_ID: Use environment variable if available, otherwise fallback to firebaseConfig.appId
// eslint-disable-next-line no-undef
const resolvedAppId = typeof __app_id !== 'undefined' ? __app_id : firebaseConfig.appId;

export const APP_ID = resolvedAppId || 'interactive-questionnaire-fallback'; 

if (!APP_ID || (APP_ID === 'interactive-questionnaire-fallback' && !firebaseConfig.appId)) {
    console.error(
        "CRITICAL: Firebase APP_ID is not defined correctly. " +
        "Ensure `firebaseConfig.appId` is set or `__app_id` is provided by the environment. " +
        "Current APP_ID resolved to:", APP_ID
    );
}

export { app, auth, db, storage };
